export const getApiBaseUrl = () => '/api';
